<template>
  <div>
    <div class="title">《三只鸟云课堂》学习平台登录</div>
    <div class="form-content">
      <a-form-model
        :rules="rules"
        :model="form"
        ref="loginForm"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        @submit="loginSubmit()"
        @submit.native.prevent
      >
        <a-form-model-item label="手机号码" prop="mobile">
          <a-input
            v-model="form.mobile"
            size="large"
            placeholder="请输入手机号码"
          />
        </a-form-model-item>
        <a-form-model-item label="验证码" prop="sms">
          <a-row :gutter="8">
            <a-col :span="12">
              <a-input
                v-model="form.sms"
                size="large"
                
                type="sms"
                placeholder="请输入验证码"
              />
            </a-col>
            <a-col :span="12">
              <a-button type="primary" size="large" block @click="sendsms()">{{
                sendText
              }}</a-button>
            </a-col>
          </a-row>
        </a-form-model-item>

        <div class="form-bottom-panel">
          <a-button type="primary" block size="large" html-type="submit"
            >立即登录</a-button
          >
        </div>
      </a-form-model>
      <div class="form-bottom">
        <div class="from-left">还没有账号？<a href="">立即注册</a></div>
        <div class="in-right"><a href="">忘记密码?</a></div>
      </div>
    </div>

    <div class="three-login">
      <div class="three-login-title">
        <div class="l-left"><div class="l"></div></div>
        <div class="text">
          第三方快捷登录<span class="color-orange">[暂未开通]</span>
        </div>
        <div class="l-right"><div class="l"></div></div>
      </div>
      <div class="three-login-content">
        <div class="item wechat">
          <a-icon type="wechat" :style="{ fontSize: '32px' }" />
        </div>
        <div class="item alipay">
          <a-icon type="alipay" :style="{ fontSize: '32px' }" />
        </div>
        <div class="item qq">
          <a-icon type="qq" :style="{ fontSize: '32px' }" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const rules = {
  mobile: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
  sms: [{ required: true, message: "请输入验证码", trigger: "blur" }],
};
export default {
  data() {
    return {
      rules,
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      form: {
        mobile: "",
        mode: 2,
        sms: "",
      },
      sendText: "发送验证码",
    };
  },
  methods: {
    sendsms() {
      let mobile = this.form.mobile.trim();
      if (/^1[0-9]{10}$/.test(mobile)) {
        this.$request.common.user
          .sms({
            mobile: mobile,
            types: 2,
          })
          .then(({ data }) => {
            if (0 === data.errcode) {
              this.$message.success("验证码发送成功");

              let sec = 60;

              let timer = setInterval(() => {
                if (0 === sec) {
                  clearInterval(timer);
                  this.sendText = `发送验证码`;
                } else {
                  this.sendText = `发送验证码(${sec})`;
                  sec--;
                }
              }, 1000);
            } else {
              this.$message.error(data.msg);
            }
          });
      } else {
        this.$message.error("请填写正确的手机号码");
      }
    },
    loginSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$request.common.user
            .login({ mode: 1, ...this.form })
            .then(({ data }) => {
              if (0 === data.errcode) {
                this.$store.set("userid", data.data.info.id);
                this.$store.set("userinfo", data.data.info);
                this.$store.set("isnewuser", data.data.isnew);
                this.$store.set("learn", data.data.learn);
                this.$message.success("登录成功");
                this.$router.push({ name: "ucenter" });
              } else {
                this.$message.error(data.msg);
              }
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  font-size: 24px;
  font-weight: 500;
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  padding-bottom: 12px;
  margin-bottom: 24px;
}
.color-orange {
  color: #f37b1d;
}

.verify {
  height: 40px;
  width: 100%;
}
.three-login-title {
  padding: 12px 0;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  position: relative;
  display: flex;
  .l-left,
  .l-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .l {
      height: 1px;
      background-color: #c1c1c1;
    }
  }

  .text {
    flex-shrink: 0;
    padding: 0 8px;
  }
}
.three-login-content {
  display: flex;
  justify-content: center;
  padding: 12px 0;
  .item {
    width: 48px;
    height: 48px;
    padding: 8px;
    border-radius: 50%;
    margin: 0 12px;

    cursor: pointer;
    background-color: #f5f5f5;
    color: #999;
  }
  .wechat {
    &:hover {
      background-color: rgb(7, 193, 96);
      color: #fff;
    }
  }
  .alipay {
    &:hover {
      background-color: rgb(34, 167, 262);
      color: #fff;
    }
  }

  .qq {
    &:hover {
      background-color: rgb(249, 173, 8);
      color: #fff;
    }
  }
}
.form-bottom {
  padding: 16px 0;
  display: flex;
  .from-left {
    flex-shrink: 0;
  }
  .in-right {
    flex: 1;
    text-align: right;
  }
}
</style>